export default __webpack_public_path__ + "static/media/08.0cbcc560.jpg";